import { Action, Subject, can, cannot, createAbility } from '@/lib/permissions';

export const usePermissions = () => {
  // TODO: Get abilities from user context or API query
  // For now, create admin abilities that allow all actions
  const abilities = createAbility([{ action: 'manage', subject: 'all' }]);

  return {
    can: (action: Action, subject: Subject) => can(abilities, action, subject),
    cannot: (action: Action, subject: Subject) =>
      cannot(abilities, action, subject),
    abilities,
  };
};
